import { computed, input, inject, Directive, output, model } from '@angular/core';
import { IOnboardingReportWidget } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { IOnboardingReportData } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-helper.service';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { FiItemsListOptionType } from '@fi-app/shared/fi-items-list/fi-items-list-option-type';
import { AppTextService } from '@fi-shared/app-text';

@Directive()
export abstract class FiOnboardingReportWidgetBaseDirective {
    public widget = model.required<IOnboardingReportWidget>();
    public reportData = input.required<IOnboardingReportData>();
    public showWidgetDetails = output<boolean>();
    public editWidget = output<IOnboardingReportWidget>();
    public deleteWidget = output<IOnboardingReportWidget>();

    protected appTextService = inject(AppTextService);
    protected fiOnboardingReportHelperService = inject(FiOnboardingReportHelperService);

    protected isCustomWidget = computed(() => !!this.widget().Name?.length);

    protected widgetName = computed(() => {
        return this.isCustomWidget()
            ? this.widget().Name
            : this.fiOnboardingReportHelperService.defaultWidgetNames[this.widget().ReportType];
    });

    protected widgetDescription = computed(() => {
        const description = this.widget().Description;
        return this.isCustomWidget() && !!description?.length
            ? description
            : this.fiOnboardingReportHelperService.defaultWidgetDescriptions[this.widget().ReportType];
    });

    protected widgetIcon = computed(() => {
        return this.fiOnboardingReportHelperService.widgetIconClasses[this.widget().ReportType];
    });

    protected widgetData = computed(() => {
        const summaryCount =
            this.reportData().ParticipantsSummary.CompletedCount +
            this.reportData().ParticipantsSummary.InProgressCount +
            this.reportData().ParticipantsSummary.NotStartedCount;

        return {
            description: this.widgetDescription(),
            icon: this.widgetIcon(),
            summaryCount,
        };
    });

    protected actions = computed<IItemsListAction2<IOnboardingReportWidget>[]>(() => {
        return this.isCustomWidget()
            ? [
                  {
                      title: this.appTextService.get('widget.rename_widget'),
                      onClick: (widget: IOnboardingReportWidget) => this.editWidget.emit(widget),
                      iconClass: 'far fa-pen-line',
                      optionType: FiItemsListOptionType.Icon,
                  },
                  {
                      title: this.appTextService.get('checklist.delete_report_widget'),
                      onClick: (widget: IOnboardingReportWidget) => this.deleteWidget.emit(widget),
                      iconClass: 'far fa-trash',
                      optionType: FiItemsListOptionType.Icon,
                  },
              ]
            : [];
    });
}
